export default __webpack_public_path__ + "static/media/MD05.da31ae71.jpg";